$(document).on('change', '.layout-option-active-checkbox', function() {
  const isActive = $(this).is(':checked');
  $(this).closest('.layout-option-row').find('input[type="text"]').prop('disabled', !isActive);
});
